import Evaluar from "pages/LandingPages/Evaluar/evaluar";

export default function EvaluarPage() {
  return <Evaluar />;
}
